import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useConnectedUser, useSessionStore } from '@tinct/core-store-session';
import { useOAuthStore } from '@tinct/core-store-oauth';
import { postLoginTarget } from '../shared';

export const DispatcherPage = () => {
  const navigate = useNavigate();
  const connectedUser = useConnectedUser();
  const accessToken = useOAuthStore((state) => state.accessToken);
  const sessionError = useSessionStore((state) => state.error);

  // Only a path of this app is followed: see postLoginTarget.
  const targetUrl = postLoginTarget(localStorage.getItem("target-url"));

  useEffect(() => {
    if (sessionError) {
      // The token was issued but the user could not be loaded for this app: without this the
      // dropped token would send us back through the SSO forever.
      navigate('/login/denied?error=session_unavailable', { replace: true });
      return;
    }

    if (!connectedUser && !accessToken) {
      navigate("/login");
      return;
    }

    if (!connectedUser && accessToken) {
      return;
    }

    localStorage.removeItem("target-url");
    if (targetUrl) {
      navigate(targetUrl);
      return;
    }

    navigate('/', { replace: true });
  }, [accessToken, connectedUser, navigate, sessionError, targetUrl])


  return (
    <div>
      <h1>Redirecting</h1>
    </div>
  );
};
